<template>
  <div
    v-if="!isLoadingCart"
    class="ecommerce-application"
  >
    <div
      v-if="directRetailers.length && !selectedDirectRetailer"
      class="mt-1 d-flex align-items-center"
    >
      Select Retailer <span class="text-danger"> * </span>
      <b-dropdown
        class="filter-dropdown w-25 ml-1"
        variant="outline-none"
        block
        no-caret
        menu-class="w-100 filter-dropdown-menu scroll-bar"
        toggle-class="filter-dropdown-toggle"
        no-flip
      >
        <template #button-content>
          <div
            class="d-flex justify-content-between"
            :class="{ 'has-value': selectedRetailer }"
          >
            <span>
              {{
                selectedRetailer
                  ? `${textTruncate(
                    selectedRetailer.entityName,
                    true,
                    25,
                    20
                  )} - ${selectedRetailer.email}`
                  : 'Select Retailer'
              }}
            </span>
            <feather-icon icon="ChevronDownIcon" />
          </div>
        </template>
        <div>
          <b-dropdown-form>
            <b-form-input
              v-model="searchText"
              placeholder="Search retailer"
            />
            <feather-icon
              icon="SearchIcon"
              class="dropdown-form-search-icon"
              size="18"
            />
          </b-dropdown-form>
        </div>
        <template v-if="allDirectRetailers.length">
          <b-dropdown-item
            v-for="option in allDirectRetailers"
            :key="option.retailerId"
            :active="option.retailerId === retailerId"
            @click="onSelectRetailer(option)"
          >
            <div>
              <span> {{ option.entityName }} - {{ option.email }} </span>
            </div>
          </b-dropdown-item>
        </template>
        <b-dropdown-item
          v-else
          disabled
        >
          No matched retailers
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div
      v-else
      class="direct-retailer-selected mt-1 d-flex align-items-center"
    >
      <span>Selected Retailer:</span>
      <strong>
        {{ selectedDirectRetailerTitle }}
      </strong>
    </div>
    <cart-total
      :key="reloadKey"
      :cart-products="cartProducts"
      :retailer-id="retailerId"
      :brand-notes="notesData"
      is-popup
      :modal-id="modalId"
      :get-cart-products-by-brand="getCartProductsByBrand"
      @remove-product-selected-from-brand="handleRemoveProduct"
      @update-notes="updateNotes"
      @remove-multiple-products="handleRemoveMultipleProducts"
    />
  </div>
  <div v-else>
    <div class="text-center p-4">
      <b-spinner />
    </div>
  </div>
</template>
<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { textTruncate } from '@/@core/utils/utils'
import {
  BDropdown,
  BDropdownForm,
  BDropdownItem,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue'
import { useBrandCart } from '@/composables/useBrandCart'
import CartTotal from './CartTotal.vue'

export default {
  components: {
    CartTotal,
    BDropdown,
    BDropdownItem,
    BDropdownForm,
    BFormInput,
    FeatherIcon,
    BSpinner,
  },
  props: {
    cartProducts: {
      type: Array,
      default: () => [],
    },
    getCartProductsByBrand: {
      type: Function,
      default: () => {},
    },
    isBrandCartUpdated: {
      type: Number,
      default: 0,
    },
    isLoadingCart: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const brandCart = useBrandCart(props)
    return { ...brandCart, textTruncate }
  },
  watch: {
    searchText(val) {
      if (val) this.debouncedTrackSearchRetailer(val)
      this.searchRetailer()
    },
    isBrandCartUpdated() {
      this.reloadKey += 1
    },
    retailerId() {
      this.$emit('get-full-selected-products', {
        retailerId: this.retailerId || null,
        productIds: this.cartProducts.map(p => p._id) || [],
      })
    },
  },
  emits: ['close-brand-cart-modal', 'get-full-selected-products'],
  mounted() {
    this.initRetailers()
  },
  methods: {
    handleRemoveProduct(product) {
      const isEmpty = this.removeProduct(product)
      if (isEmpty) this.$emit('close-brand-cart-modal')
    },
    handleRemoveMultipleProducts(productIds) {
      const isEmpty = this.removeMultipleProducts(productIds)
      if (isEmpty) this.$emit('close-brand-cart-modal')
    },
  },
}
</script>

<style lang="scss" scoped>
.direct-retailer-selected {
  gap: 0.5rem;
}
</style>
